export const pizzaHalvesArticles = [
    "00001",
    "00002",
    "00005",
    "00006",
    "00007",
];
